/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Tags_LabelInputs */



/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Paste_Attributes_Tags_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_tags_label = /** @type {((inputs?: Paste_Attributes_Tags_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Tags_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "it") return /** @type {LocalizedString} */ ("Etichette")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Теги")
	if (locale === "es") return /** @type {LocalizedString} */ ("Etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Etiquetas")
	return /** @type {LocalizedString} */ ("Tags")
});